import React from 'react';
import Handler from '../../Handler';
import Button from '@mui/material/Button';

export const CardReductionStatus = (props) => {
  const { data, onAction } = props;
  const { lastDoc } = data;
  const { actionSeq, nextActions } = lastDoc;
  console.log('CardReductionStatus actionSeq', actionSeq);
  console.log('CardReductionStatus nextActions', nextActions);

  const buildButtonColor = (value) => {
    switch (value) {
      case 'CancelRejected':
      case 'CanceledReductionCert':
      case 'ReductionCertRejected': {
        return 'secondary';
      }
      default: {
        return 'primary';
      }
    }
  };

  const isDegree = (status) => {
    switch (status) {
      case 'WaitingForAuditReductionCert':
      case 'AuditReductionCert': {
        return true;
      }
      default: {
        return false;
      }
    }
  };

  return (
    <article className='card-project-status'>
      <header>
        <h3>상태 정보</h3>
      </header>
      <article className='content__box'>
        <div className='status__box'>
          <header>
            <span>상태</span>
          </header>
          <div className='value'>
            <span>
              {Handler.ENUM.REDUCTION_ACTION.STATUS(actionSeq.status)}{' '}
              {isDegree(actionSeq.status) ? `(${actionSeq.degree})` : ''}
            </span>
            <span className='date'>({Handler.getYYYYMMDDByUnix(actionSeq.createdAt)})</span>
          </div>
        </div>
        <div className='action__box'>
          <ul>
            {nextActions.map((item, index) => {
              return (
                <li>
                  <Button
                    color={buildButtonColor(item)}
                    variant='contained'
                    onClick={() => {
                      onAction(item);
                    }}
                  >
                    {Handler.ENUM.REDUCTION_ACTION.NEXT(item)}
                  </Button>
                </li>
              );
            })}
          </ul>
        </div>
      </article>
    </article>
  );
};
